import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import "../../style/adminreport.css";
import "../../style/reportdentist1.css";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { apiAxios } from "../../utils/apiAxios";
import { OrderDropdownItem } from "../CentralHub/Admin/Interfaces/OrderDropdownItem";
import { OrderTypeDropdownItem } from "../CentralHub/Admin/Interfaces/OrderTypeDropdownItem";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

interface OrderRow {
  orderId: number;
  clinic: string;
  type: string;
  assignedHub: string;
  assignedDesigner: string;
  partner: string;
  paymentType: string;
  paymentStatus: string;
  expectedDelivery: string;
  phone: string;
  payment: number;
  status: string;
}

const DeliveryPartnerReport = () => {
  const [tableData, setTableData] = useState<OrderRow[]>([]);
  const [loading, setLoading] = useState(false);
 const [orderDropdown, setOrderDropdown] = useState<OrderDropdownItem[]>([]);
  const [orderTypeDropdown, setOrderTypeDropdown] = useState<OrderTypeDropdownItem[]>([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const [filters, setFilters] = useState<{
  orderId: string;
  type: number | null;   // ✅ FIX
}>({
  orderId: "",
  type: null,
});



  const fetchReport = async () => {
    try {
      setLoading(true);
  
      const payload = {
          orderId: filters.orderId,
          orderTypeID: filters.type,
          fromDate: startDate?.toISOString(),
          toDate: endDate?.toISOString(),
          search: search,
        };
      // const res = await apiAxios.post(
      //   `${API_BASE_URL}/MillingHub/get-report`, // ✅ FIXED ENDPOINT
      //   payload
      // );
       const res = await apiAxios.post(
              `${API_BASE}/DeliveryPartner/GetDeliveryOrderReport`,payload);
   console.log(res,"****fetchReport******");
  
      if (res.data?.isSuccess) {
        const mapped = (res.data.singleData || []).map((item: any) => ({
          orderId: item.orderID,
          clinic: item.clinicName || "",
          type: item.orderType || "",
          assignedHub: item.hubName || "",
          assignedDesigner: item.designerName || "",
          partner: item.deliveryPartner || "",
          paymentType: item.paymentType || "",
          paymentStatus: item.paymentStatus || "",
          expectedDelivery: item.expectedDelivery || "",
          phone: item.phone || "",
          payment: item.amount || 0,
          status: (item.status || "").toUpperCase(),
        }));
  
        setTableData(mapped);
      }
    } catch (err) {
      console.error("Milling report error:", err); // ✅ updated label
    } finally {
      setLoading(false);
    }
  };
  

  const fetchReports = async () => {
    try {
      setLoading(true);

      const payload = {
        OrderId: filters.orderId,
        OrderTypeID: filters.type,
        FromDate: startDate?.toISOString(),
        ToDate: endDate?.toISOString(),
        Search: search,
      };

      const res = await apiAxios.post(
        `${API_BASE}/DeliveryPartner/GetDeliveryOrderReport`,payload);
        console.log(res,"****fetchReports******");
      if (res.data?.isSuccess) {
        const mapped = (res.data.singleData || []).map((item: any) => ({
          orderId: item.orderID,
          clinic: item.clinicName || "",
          type: item.orderType || "",
          assignedHub: item.hubName || "",
          assignedDesigner: item.designerName || "",
          partner: item.deliveryPartner || "",
          paymentType: item.paymentType || "",
          paymentStatus: item.paymentStatus || "",
          expectedDelivery: item.expectedDelivery || "",
          phone: item.phone || "",
          payment: item.amount || 0,
          status: (item.status || "").toUpperCase(),
        }));

        setTableData(mapped);
      }
    } catch (err) {
      console.error("Delivery report error:", err);
    } finally {
      setLoading(false);
    }
  };
   useEffect(() => {
      loadDropdowns();
    }, []);
  const loadDropdowns = async () => {
      try {
        const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
        const [
          orderRes,
          typeRes,
        ] = await Promise.all([
          apiAxios.post(`${API_BASE}/DeliveryPartner/GetAllCasesDashBoard`, {
            clinicId: selectedClinic.clinicID
          }),
          apiAxios.get(`${API_BASE}/Central/order-type-dropdown`),
        ]);
  
        if (orderRes.data?.isSuccess) setOrderDropdown(orderRes.data.singleData);
        if (typeRes.data?.isSuccess) setOrderTypeDropdown(typeRes.data.data);
  
      } catch (err) {
        console.error("Dropdown error:", err);
      }
    };
const orderOptions = (orderDropdown || []).map(item => ({
    value: item.orderID.toString(),
    label: `${item.orderID} (Case ${item.caseID})`
  }));

  const typeOptions = (orderTypeDropdown || []).map(item => ({
  value: item.orderTypeID,     // ✅ FIX
  label: item.orderTypeName
}));
  const handleClear = () => {
    setFilters({
      orderId: "",
      type: 0,
    });
    setSearch("");
    setStartDate(null);
    setEndDate(null);
    
    setTableData([]);
  };

  const filteredData = tableData;

  const totalOrders = filteredData.length;

  const completedOrders = filteredData.filter(
    (x) => (x.status || "").toLowerCase() === "completed"
  ).length;

  const pendingOrders = filteredData.filter(
    (x) => (x.status || "").toLowerCase() !== "completed"
  ).length;

  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: OrderRow) => row.orderId,
        sortable: true,
      },
      // {
      //   name: "Clinic",
      //   selector: (row: OrderRow) => row.clinic,
      // },
      {
        name: "Type",
        selector: (row: OrderRow) => row.type,
      },
  
     {
  name: "Status",
  cell: (row: OrderRow) => {
    const statusStyles: Record<string, { bg: string; color: string }> = {
      completed: { bg: "#d1fae5", color: "#065f46" },
      ready_for_delivery: { bg: "#dbeafe", color: "#1e40af" },
      pending_acceptance: { bg: "#fef3c7", color: "#92400e" },
      delay_report: { bg: "#fee2e2", color: "#991b1b" },
      pending: { bg: "#f3f4f6", color: "#374151" },
      cancelled: { bg: "#dc3545", color: "#fff" }
    };

    const status = (row.status || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "_");

    const style = statusStyles[status] || {
      bg: "#f3f4f6",
      color: "#374151",
    };

    return (
      <span
        style={{
          backgroundColor: style.bg,
          color: style.color,
          padding: "5px 10px",
          borderRadius: "4px",
          fontSize: "12px",
          fontWeight: 500,
          display: "inline-block",
          textTransform: "capitalize",
          whiteSpace: "nowrap",
          cursor: "pointer",
        }}
      >
        {row.status || "-"}
      </span>
    );
  },
  width: "190px",
}
    ],
    []
  );

  // ✅ Excel Export
  const exportExcel = () => {
    const exportData = filteredData.map((d) => ({
      "Order ID": d.orderId,
      //Clinic: d.clinic,
      Type: d.type,
      // Hub: d.assignedHub,
      // Partner: d.partner,
      Status: d.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Delivery Report");

    XLSX.writeFile(workbook, "Delivery_Report.xlsx");
  };

  // ✅ PDF Export
const exportPDF = () => {
  const doc = new jsPDF("landscape");

  // Report Heading
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Delivery Partner Report", pageWidth / 2, 15, {
    align: "center",
  });

  const tableColumn = [
    "Order ID",
    "Type",
    "Status",
  ];

  const tableRows = filteredData.map((d) => [
    d.orderId,
    d.type,
    d.status,
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 25,   // heading ke neeche table
    styles: {
      fontSize: 8,
      halign: "center",
    },
    headStyles: {
      fillColor: [22, 160, 133],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
    },
  });

  doc.save("Delivery_Report.pdf");
};

  return (
    <div className="container-fluid">
      {/* HEADER */}
      <div className="mb-4 report-design-heading">
        <h4 className="mb-4">Delivery Partner Report</h4>
        <p className="text-muted mt-0 track-all-order">
          Track all delivery orders and status
        </p>
      </div>

      {/* SUMMARY */}
      <div className="order-status-bar mb-4">
        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>
        </div>

        <div className="status-col">
          <h3>{completedOrders}</h3>
          <div className="badge-box badge-success">Completed</div>
        </div>

        <div className="status-col">
          <h3>{pendingOrders}</h3>
          <div className="status-badge warning">Pending</div>
        </div>
      </div>

      {/* FILTER */}
      <div className="premium-card mb-4 p-3">
        <div className="row g-3 px-2 py-3">

          <div className="col-md-4 col-lg-3">
            <Select
              options={orderOptions}
              value={orderOptions.find(o => o.value === filters.orderId) || null}
              onChange={(selected) =>
                setFilters(prev => ({ ...prev, orderId: selected?.value || "" }))
              }
              placeholder="Select Order"
              isClearable
              menuPortalTarget={document.body}
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          </div>

           {/* Order Type */}
          <div className="col-md-4 col-lg-3">
            <Select
  options={typeOptions}
  value={typeOptions.find(o => o.value === filters.type) || null}
  onChange={(selected) =>
    setFilters(prev => ({
      ...prev,
      type: selected ? selected.value : null   // ✅ FIX
    }))
  }
  placeholder="select Order Type"
  isClearable
  menuPortalTarget={document.body}
  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
/>
          </div>

       <div className="col-md-4 col-lg-3 position-relative">
  <DatePicker
    selected={startDate}
    onChange={(date) => setStartDate(date)}
    placeholderText="Start Date"
    className="form-control pe-5"
    dateFormat="dd-MM-yyyy"
  />

  <i className="bi bi-calendar3 newicon position-absolute"></i>
</div>

          <div className="col-md-4 col-lg-3 position-relative">
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control"
              dateFormat="dd-MM-yyyy"
            />
              <i className="bi bi-calendar3 newicon position-absolute"></i>
          </div>

          <div className="col-md-4 col-lg-3">
            <input
              className="form-control"
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          <div className="col-md-4 col-lg-4 d-flex gap-2">
            <button className="btn btn-primary" onClick={fetchReport}>
              Search
            </button>

            <button className="btn btn-secondary" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="premium-card p-4">
        <div className="d-flex justify-content-end gap-2 mb-3">
          <button
  className={`btn btn-success ${filteredData.length === 0 ? "disabled" : ""}`}
  onClick={exportExcel}
  disabled={filteredData.length === 0}
>
  Export Excel
</button>

    
<button
  className="btn btn-danger"
  onClick={exportPDF}
  disabled={filteredData.length === 0}
>
  Export PDF
</button>
        </div>

        <DataTable
          columns={columns}
          data={filteredData}
          progressPending={loading}
          pagination
          highlightOnHover
          striped
          responsive
          fixedHeader
          fixedHeaderScrollHeight="500px"
        />
      </div>
    </div>
  );
};

export default DeliveryPartnerReport;